import { FileUploadFile } from 'primereact/fileupload';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import { uploadFileAndRetrieveFileUrl } from '../../../../../../../../api/operations/files/upload-file-and-retrieve-file-url';
import { AssignmentStudent } from '../../../../../../../../api/types/assignment-student-details/response/assignment-student-db';

export const taskGradeUploadFileOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number | undefined,
  studentId: number | null,
  file: FileUploadFile | undefined,
  setStudentData: (assignments: AssignmentStudent[]) => any,
  setStudentDataUpdated: (assignments: AssignmentStudent[]) => any,
  hideDialog: () => any,

  onHide: () => any,
) => {
  try {
    if (!programId || !courseId || !assignmentId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    if (!studentId) {
      toast.warn('לא ניתן לאתר את מזהה הסטודנט, נסה שוב בעוד מספר רגעים...');
      return;
    }
    if (!file) {
      toast.warn('תחילה יש להעלות קובץ');
      return;
    }

    const fileExtension = file.name.split('.').pop();
    if (!fileExtension?.length) {
      toast.warn(
        'לא ניתן לאתר את סוג הקובץ, נסה להוסיף סיומת לקובץ והעלאה מחדש',
      );
      return;
    }

    const preSignUrlRes = await appApi.getAssignmentStudentPreSignUrl(
      programId!,
      courseId!,
      assignmentId,
      1,
      fileExtension,
    );

    const fullUrl = await uploadFileAndRetrieveFileUrl(
      preSignUrlRes.data.body,
      file,
    );

    if (!fullUrl) {
      throw new Error('Can not find uploaded path');
    }

    const preSignUrlRes2 =
      await appApi.assignmentStudentFileUploadedNotifyBackend(
        programId!,
        courseId!,
        assignmentId,
        studentId,
        fullUrl,
        file.name,
      );

    setStudentData(preSignUrlRes2.data.body);
    setStudentDataUpdated(preSignUrlRes2.data.body);
    hideDialog();
    onHide();
  } catch (e) {
    toast.error('העלאת קובץ נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `uploadFileOperation is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId}, fileName: ${file?.name} with the error: ${e}`,
    );
  }
};
